import LangEnum from '../../../../lang/LangEnum';
import { CatalogTestIds } from '../../../../utils/testIds/catalog.testIds';
import { CatalogCreationBooleanOptions } from '../catalogCreationForm.types';
import CatalogCreationBooleanSelectField from './CatalogCreationBooleanSelectField';

export const PRODUCT_WITHOUT_MEDIA_OPTIONS: CatalogCreationBooleanOptions = [
  { value: false, label: LangEnum.GLOBAL_SHOW },
  { value: true, label: LangEnum.GLOBAL_HIDE },
];

const CatalogCreationProductWithoutMediaField = () => (
  <CatalogCreationBooleanSelectField
    name="withMedia"
    label={LangEnum.CATALOGS_CREATION_MODAL_PRODUCT_WITHOUT_MEDIA}
    options={PRODUCT_WITHOUT_MEDIA_OPTIONS}
    testId={CatalogTestIds.CATALOG_CREATION_MODAL_PRODUCT_WITHOUT_MEDIA}
  />
);

export default CatalogCreationProductWithoutMediaField;
